import { CustomFontAwesomeIconProps } from './types'

import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Hide = (props: CustomFontAwesomeIconProps) => <FontAwesomeIcon {...props} icon={faEyeSlash} />

export default Hide
